type TFunction = (key: string, options?: Record<string, unknown>) => string;

export const formatGuestSummary = (
  t: TFunction,
  adultCount: number,
  childCount: number,
  childrenAges: number[]
): string => {
  const parts: string[] = [];

  if (adultCount > 0) {
    parts.push(t("guestCountLabel.adultCount", { count: adultCount }));
  }

  if (childCount > 0) {
    if (childrenAges.length > 0) {
      parts.push(
        t("hotelTrips.childWithAge", {
          count: childCount,
          ages: childrenAges.join(", "),
        })
      );
    } else {
      parts.push(t("guestCountLabel.childCount", { count: childCount }));
    }
  }

  return parts.join(", ");
};
